
import React from 'react'
import Nophotocover from './Nophotocover'
import PhotoCover from '../../Theme1/Cover/PhotoCover'
import CoverController from '../../common/CoverController'

const Cover = ({details,photoMode}) => {

  return (
  <CoverController 
   details={details}
  photoMode={photoMode}
      PhotoComponent={PhotoCover}
      NoPhotoComponent={Nophotocover}
  />
  )
}

export default Cover